<template>
  <section>
    <!-- Menu -->
    <top-menu/>

    <section>
      <page-header :headerName="'Lista de Pagamentos'" :showBtn="false" :btnName="''" :btnRoute="''"
                   :css="'container-fluid'"/>

      <div class="page-content">
        <div class="container-fluid">
          <div class="row">
            <!-- Loading from page -->
            <full-loading v-if="loadingList"/>

            <!-- No Result -->
            <div v-if="!loadingList && (dataPayment !== '' && !dataPayment.length) && !failRequest"
                 class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box content-default">
                <p>Sem resultado na pesquisa.</p>
              </div>
            </div>

            <!-- Fail Request -->
            <div v-if="!loadingList && failRequest" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box content-default">
                <p>Falha na requisição.</p>
              </div>
            </div>

            <!-- Table -->
            <div v-if="!loadingList && dataPayment.length" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box orderBy">
                <div class="portlet-title">
                  <div class="caption">
                    <span
                      class="caption-subject font-blue bold uppercase">Quantidade total de pagamento ({{ qtdTotal }})</span>
                  </div>
                </div>

                <div class="portlet-body contate-table offset-top-20">
                  <div class="table-scrollable table-scrollable-borderless">
                    <table class="table table-hover table-light table-icon">
                      <thead>
                      <tr>
                        <th> EMPRESA</th>
                        <th> FUNCIONÁRIOS</th>
                        <th> PAGAMENTO POR</th>
                        <th> PREÇO</th>
                        <th> POR FUNCIONÁRIO</th>
                        <th> VALOR TOTAL</th>
                        <th> STATUS</th>
                        <th> DATA VENCIMENTO</th>
                        <th> DATA PAGAMENTO</th>
                        <th> AÇÕES</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="dt in dataPayment">
                        <td>{{ dt.companyName }}</td>
                        <td>{{ dt.employees }}</td>
                        <td>{{ dt.paymentMethodStr }}</td>
                        <td>{{ dt.price | currency('R$', 2, {decimalSeparator: ','}) }}</td>
                        <td>{{ dt.pricePerEmployee | currency('R$', 2, {decimalSeparator: ','}) }}</td>
                        <td>{{ dt.totalCost | currency('R$', 2, {decimalSeparator: ','}) }}</td>
                        <td>{{ dt.paymentStatusStr }}</td>
                        <td>{{ dt.expireAtStr }}</td>
                        <td>{{ dt.paidAtStr }}</td>
                        <td>
                          <a v-bind:href="'/detalhe-pagamento/' + dt.id + '/' + dt.subscriptionId" title="Visualizar"
                             class="btn-to-view">
                            <i class="fa fa-eye" aria-hidden="true"></i> Visualizar
                          </a>
                          <a v-on:click="cancelInvoice(dt.id)" title="Cancelar Boleto" class="btn-to-delete">
                            <i class="fa fa-times" aria-hidden="true"></i> Cancelar
                          </a>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <!-- Pagination -->
                <paginate v-if="totalPages > 1"
                          v-model="pageNumber"
                          :page-count="totalPages"
                          :click-handler="listPayment"
                          :prev-text="'Anterior'"
                          :next-text="'Próximo'"
                          :container-class="'pagination'"
                          :page-class="'page-item'">
                </paginate>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import topMenu from "../../../components/default/topMenu.vue";
import pageHeader from "../../../components/default/pageHeader.vue";
import fullLoading from "../../../components/default/fullLoading.vue";
import swal from 'sweetalert';

import {PAYMENTS, CANCEL_INVOICE} from "../../../../../urlConfig";
import {REQUEST_SERVICE} from "../../../../../requestConfig";
import {UTIL_SERVICE} from "../../../../../requestConfig";
import {UTIL} from "../../../../../utils";

export default {
  name: "list-payment",
  components: {
    topMenu,
    pageHeader,
    fullLoading
  },
  data() {
    return {
      failRequest: false,
      loadingList: false,
      pageNumber: 1,
      qtdTotal: 0,
      pageQtd: 20,
      totalPages: 0,
      dataPayment: {}
    }
  },
  methods: {
    listPayment(page) {
      this.loadingList = true;

      if (page) this.pageNumber = page;

      let url = PAYMENTS;
      url += "?pageNumber=" + this.pageNumber + "&pageQtd=" + this.pageQtd;

      REQUEST_SERVICE.get(url).then((response) => {
        UTIL_SERVICE.console("RESULT PAYMENTS:", response.data);

        this.dataPayment = response.data.items;
        this.qtdTotal = response.data.totalItems;
        this.totalPages = (response.data.totalItems / this.pageQtd);

        this.loadingList = false;
        this.failRequest = false;
      }).catch((reason) => {
        this.loadingList = false;
        this.failRequest = true;
        reason.response.data.erros.map((value, index) => {
          swal("Aviso", value.value, "error");
        });
      });
    },
    cancelInvoice(id) {
      this.loadingList = true;
      REQUEST_SERVICE.get(CANCEL_INVOICE + id).then((response) => {
        UTIL_SERVICE.console("RESULT CANCEL_INVOICE:", response.data);
        swal("Aviso", response.data, "success");

        this.listPending(1);
      }).catch((reason) => {
        this.loadingList = false;
        reason.response.data.erros.map((value, index) => {
          swal("Aviso", value.value, "error");
        });
      });
    }
  },
  beforeMount() {
    this.listPayment();

    if (UTIL.checkP(JSON.parse(window.localStorage.getItem('mamUserMasterInfo')).id) === false) {
      this.$router.push({path: '/'});
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/vue/pages/restricted/payment/listPayment/listPayment.vue